export const AGENCY_FRANCHISING_URL = 'https://travelatapro.ru/franchising';
